import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'
import { SystemlogResolvedType, SystemlogSort, SystemlogType } from 'src/Libs/installations/types'
import { PlaceholderOptions } from 'src/Types/globalTypes'

interface SystemlogTranslations {
  translatedTypeOptions: PlaceholderOptions<SystemlogType>
  translatedStatusOptions: PlaceholderOptions<SystemlogResolvedType>
  translatedSortOptions: PlaceholderOptions<SystemlogSort>
}
export const useTranslatedSystemlogOptions = (): SystemlogTranslations => {
  const { t } = useCustomTranslation()

  const translatedTypeOptions = {
    placeholder: t('systemlog.typeFilter'),
    options: [
      { label: t('common.warning'), value: SystemlogType.Warning },
      { label: t('common.error'), value: SystemlogType.Error },
    ],
    fieldName: 'errorType',
  }

  const translatedStatusOptions = {
    placeholder: t('systemlog.statusFilter'),
    options: [
      { label: t('common.open'), value: SystemlogResolvedType.Open },
      { label: t('common.closed'), value: SystemlogResolvedType.Closed },
    ],
    fieldName: 'isResolved',
  }

  const translatedSortOptions = {
    placeholder: t('systemlog.sortFilter'),
    options: [
      { label: t('common.dateDesc'), value: SystemlogSort.Descending },
      { label: t('common.dateAsc'), value: SystemlogSort.Ascending },
    ],
    fieldName: 'createdAt',
  }

  return {
    translatedSortOptions,
    translatedStatusOptions,
    translatedTypeOptions,
  }
}
